"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __importDefault(require("angular"));
class RefreshWarning {
    constructor(XucPhoneState, CtiProxy, $window, electronWrapper, JitsiProxy) {
        this.XucPhoneState = XucPhoneState;
        this.CtiProxy = CtiProxy;
        this.$window = $window;
        this.electronWrapper = electronWrapper;
        this.JitsiProxy = JitsiProxy;
        this.restrict = 'A';
        this.isolatedScope = {
            'eventRegistered': '='
        };
        this.webrtcCallOngoing = false;
        this.videoOngoing = false;
    }
    link(scope) {
        this.isolatedScope = angular_1.default.extend(scope, this.isolatedScope);
        const beforeUnloadHandler = (event) => {
            window.onpagehide = function () { afterUnloadConfirmation(); };
            event.preventDefault();
            event.returnValue = true;
        };
        const afterUnloadConfirmation = () => {
            if (this.CtiProxy.isUsingWebRtc()) {
                this.XucPhoneState.getCalls().map(call => this.CtiProxy.hangup(call.uniqueId));
            }
            if (this.JitsiProxy.videoIsOngoing())
                this.JitsiProxy.dismissVideo();
            if (this.isolatedScope.eventRegistered) {
                this.$window.removeEventListener("beforeunload", beforeUnloadHandler);
                this.electronWrapper.setElectronConfig({ confirmQuit: { reset: true } });
                this.isolatedScope.eventRegistered = false;
            }
        };
        const dialog = {
            type: 'question',
            buttons: ['DIALOG_CANCEL', 'DIALOG_QUIT'],
            defaultId: 1,
            message: 'DIALOG_MSG',
            detail: 'DIALOG_DETAIL'
        };
        const watchEventHandler = (ref, isOngoing) => {
            switch (ref) {
                case 'XucPhoneState':
                    this.webrtcCallOngoing = isOngoing;
                    break;
                case 'JitsiProxy':
                    this.videoOngoing = isOngoing;
                    break;
            }
            if (this.webrtcCallOngoing || this.videoOngoing) {
                if (!this.isolatedScope.eventRegistered) {
                    this.$window.addEventListener("beforeunload", beforeUnloadHandler);
                    this.electronWrapper.setElectronConfig({ confirmQuit: dialog });
                    this.isolatedScope.eventRegistered = true;
                }
            }
            else {
                this.$window.removeEventListener("beforeunload", beforeUnloadHandler);
                this.electronWrapper.setElectronConfig({ confirmQuit: { reset: true } });
                this.isolatedScope.eventRegistered = false;
            }
        };
        scope.$watch(() => {
            return this.XucPhoneState.getCalls().length;
        }, (newValue, oldValue) => {
            if (newValue > 0 && newValue != oldValue)
                watchEventHandler('XucPhoneState', true);
            else
                watchEventHandler('XucPhoneState', false);
        });
        scope.$watch(() => {
            return this.JitsiProxy.videoIsOngoing();
        }, (newValue, oldValue) => {
            if (newValue !== oldValue && newValue == true)
                watchEventHandler('JitsiProxy', true);
            else
                watchEventHandler('JitsiProxy', false);
        });
        scope.$on('$destroy', () => {
            afterUnloadConfirmation();
        });
    }
}
exports.default = RefreshWarning;
RefreshWarning.$inject = [
    "XucPhoneState", "CtiProxy", "$window", "electronWrapper",
    "JitsiProxy"
];
